<script>
    // core components
    import VehiculoView from "../../viewsERP/Vehiculo.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <VehiculoView />
    </div>
  </div>